import { render, staticRenderFns } from "./SddfFileUploader.vue?vue&type=template&id=fdd4807c&scoped=true&"
import script from "./SddfFileUploader.vue?vue&type=script&lang=js&"
export * from "./SddfFileUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@2.1.1_webpack@4.47.0__ejs@3.1.10_lodash@4.17.21_vue-templ_3032bbf5bf429ce3df9c2338882a5f47/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd4807c",
  null
  
)

export default component.exports